import { CatalogItem } from '@nrdy-marketing-engine/cart/@types/catalog-item';
import fetchQuote from './fetch-quote';
import fetchItem from './line-item/fetch-item';

interface FetchCatalogItemProps {
  catalogItemId?: string;
  jurisdictionId?: number;
  quoteId?: string;
}

interface FetchCatalogItemResult {
  catalogItem: CatalogItem;
  jurisdictionId: number;
}

const getQuoteData = async (quoteId: string) => {
  const quote = await fetchQuote(quoteId);
  const item = quote.items[0];

  return {
    catalogItemId: item.item_id,
    jurisdictionId: quote.jurisdiction_id,
    promotionPriceCents: item.promotions?.length ? item.quoted_price_cents : undefined,
  };
};

const fetchQuotedCatalogItem = async (quoteId: string): Promise<FetchCatalogItemResult> => {
  const { catalogItemId, jurisdictionId, promotionPriceCents } = await getQuoteData(quoteId);
  const catalogItem = await fetchItem(catalogItemId, jurisdictionId);

  return {
    catalogItem: { ...catalogItem, quoted_price_cents: promotionPriceCents },
    jurisdictionId,
  };
};

export default async function fetchCatalogItem({
  catalogItemId,
  jurisdictionId = 1,
  quoteId,
}: FetchCatalogItemProps): Promise<FetchCatalogItemResult> {
  if (quoteId) return fetchQuotedCatalogItem(quoteId);

  const catalogItem = await fetchItem(catalogItemId, jurisdictionId);
  return { catalogItem, jurisdictionId };
}
